import { schema } from 'normalizr';

export const variableSchema = new schema.Entity('variables');

export const addOnDefSchema = new schema.Entity('addOnDefs', {
  formula: {
    variables: [variableSchema],
  },
});
